import React from "react"
import { CerberusPreview } from "@blackpearlmail/cerberus"

import { Actions } from "../../components/actions"
import { IPreviewProps } from "./model"

import "./style.scss"

const defaultValues = {
    "default/name": "Taylor James",
    "default/position": "Co-founder",
    "default/workphone": "202-555-0174",
    "default/orgname": "Salt & Sweet",
    "default/website": "saltandsweet.com",
    "default/facebook": "https://facebook.com",
    "default/twitter": "https://twitter.com",
    "default/instagram": "https://instagram.com",
    "default/linkedin": "https://linkedin.com",
    "default/youtube": "https://youtube.com",
    "default/tiktok": "https://tiktok.com",
}

export const Preview = (props: IPreviewProps) => {
    const { template, mobileDisplay, signatureData, submit } = props

    return (
        <div id="template-preview" className={`eml-preview ${!mobileDisplay ? "mbl-hidden" : ""}`}>
            <CerberusPreview
                dynamicHeight={true}
                signatureData={{ ...defaultValues, ...signatureData }}
                template={template}
            />
            <Actions className="mbl-only" submit={submit} mobileDisplay />
        </div>
    )
}
